import { Injectable } from '@angular/core';
import { buildGraphQLFields } from 'src/app/helpers/datesFormat';
import { environment } from 'src/environments/environment';
import { GraphService } from './graph.service';
import { NotaCreditoProveedor } from './models/file';
@Injectable({
  providedIn: 'root',
})
export class NotaCreditoProveedorService {
  appBranch = environment.appEnv;
  constructor(private queryGQL: GraphService) {}

  createNotaCreditoProveedor({
    notaCredito,
    usuario,
  }: {
    notaCredito: NotaCreditoProveedor;
    usuario: string;
  }) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation createNotaCreditoProveedor($notaCredito:inputNotaCreditoProveedor_Dto!,$usuario:String!) {
          createNotaCreditoProveedor(notaCredito: $notaCredito,usuario:$usuario){
              id, 
              codigo,
              idOrdenIngreso,
          }
      }`,
      variables: { usuario, notaCredito },
    });
  }

  getNotaCreditoProveedorByNumberOS({
    numberOS,
    ProjectionExpression,
  }: {
    numberOS: string;
    ProjectionExpression?: string;
  }) {
    const fields = ProjectionExpression
      ? buildGraphQLFields(ProjectionExpression.split(',').map((f) => f.trim()))
      : 'id, numberOS, codigo, estado';

    const query = `query getNotaCreditoProveedorByNumberOS($numberOS: String!, $ProjectionExpression:String,) {
      getNotaCreditoProveedorByNumberOS(numberOS: $numberOS, ProjectionExpression: $ProjectionExpression) {   
          ${fields}       
      }
    }`;
    return this.queryGQL.queryGraphQLSales<{
      getNotaCreditoProveedorByNumberOS: any;
    }>({
      query,
      variables: { numberOS, ProjectionExpression },
    });
  }
  deleteNotaCreditoProveedor({ id }: { id: string }) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation deleteNotaCreditoProveedor($id:String!) {
            deleteNotaCreditoProveedor(id:$id)
      }`,
      variables: { id },
    });
  }

  updateNotaCreditoProveedor({ id, updates }: { id: string; updates: any }) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation updateNotaCreditoProveedor($id:String!, $updates:inputNotaCreditoProveedor_Dto!) {
            updateNotaCreditoProveedor(id:$id updates: $updates){
            id,
            reef,
            saf,
            penalidad,
            partialPayment
            }
      }`,
      variables: { id, updates },
    });
  }
}
